module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"PUPPY_SIGNUP_COMING_SOON":"Anmeldung ab 13. Juli 2025 möglich."},"en":{"PUPPY_SIGNUP_COMING_SOON":"Sign up opens July 13, 2025."}}')
  delete Component.options._Ctor
}
